export default "__VITE_ASSET__CcBs9eAf__"